<template>
    <aside class="dx-navbar-aside" :class="{ 'collapsed': hidden }">
    <slot></slot>
  </aside>
</template>

<script>
export default {
  name: 'dx-navbar-aside',

  props: {
    hidden: {
      type: Boolean,
    },
  },

  data() {
    return {
      classes: {
        'dx-navbar-aside': !this.hidden,
        'dx-navbar-aside-hidden': this.hidden,
      },
    };
  },
};
</script>

<style scoped lang="scss">
.dx-navbar-aside {
  width: var(--dx-navbar--aside-width);
  height: calc(100vh - var(--dx-topbar--height));
  position: fixed;
  overflow-y: auto;
  top: var(--dx-topbar--height);
  left: 0;
  z-index: var(--dx-zindex-dropdown-menu);
  padding: var(--dx-space-size--sm) 0;
  box-sizing: border-box;
  background-color: var(--dx-color--white);
  border-left: 1px solid var(--dx-color--blue-light);
  border-right: 1px solid var(--dx-color--blue-light);
  box-shadow: 0px 0px 20px 0px rgba(0,0,0,0.05);
  border-radius: 2px;
  cursor: default !important;
  transition: width 0.3s ease;
}

.collapsed {
  width: 32px;
  overflow: hidden;
}
</style>
